module.exports = __webpack_public_path__ + "static/img/romanforum.089f022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/romanforum.jpg
// module id = P+2j
// module chunks = 1